import React from 'react';
import { styled } from 'baseui';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { LabelMedium } from 'baseui/typography';

const ChartContainer = styled('div', {
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  padding: '20px',
  minHeight: '400px',
  display: 'flex',
  flexDirection: 'column',
});

const ChartHeader = styled('div', {
  marginBottom: '16px',
});

interface InOutChartProps {
  inCount: number;
  outCount: number;
}

export const InOutChart: React.FC<InOutChartProps> = ({ inCount, outCount }) => {
  const data = [
    {
      name: 'Status',
      'Currently In': inCount,
      'Checked Out': outCount,
    },
  ];

  return (
    <ChartContainer>
      <ChartHeader>
        <LabelMedium margin={0}>Current Status</LabelMedium>
      </ChartHeader>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Currently In" fill="#2196F3" radius={[8, 8, 0, 0]} />
          <Bar dataKey="Checked Out" fill="#607D8B" radius={[8, 8, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};
